<template>
  <StyledDiv class="fullPage">
    <Splash />
    <Ph2SupplementContent />
    <!-- <TedTalk /> -->
  </StyledDiv>
</template>

<script>
import { StyledDiv } from "./styled";
import Ph2SupplementContent from './components/Ph2SupplementContent';
// import Splash from "./components/Splash";
// import TedTalk from "./components/TedTalk";

// eslint-disable-next-line
import styles from './global.css';

export default {
  components: {
    StyledDiv,
    Ph2SupplementContent
    // TedTalk,
    // Splash,
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style>
body,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
.fullPage {
  height: 100%;
}
</style>
